import Flickity from 'flickity';

const mxlMethods: LegacyModule = {
	hoverEnabled: true,
	hoverBasedActiveState: false,
	currentMethodIndex: 0,

	init: function () {
		this.cache();
		this.events();
		this.initRotator();
		this.initLegend();
	},

	cache: function () {
		this.$methodsSection = document.getElementById('moviXLMethods');

		this.$methodToggles = this.$methodsSection.querySelectorAll('.methodSelect .method');

		this.$rotator = this.$methodsSection.querySelector('.methodRotator');
		this.$rotatorComponents = this.$rotator.querySelectorAll('.component');
		this.$rotatorBullets = this.$rotator.querySelectorAll('.bullet');

		this.$legend = this.$methodsSection.querySelector('.methodLegend');
		this.$legendCells = this.$legend.querySelectorAll('.cell');
		this.$legendComponents = this.$legend.querySelectorAll('.component');
	},

	events: function () {
		for (var i = this.$methodToggles.length - 1; i >= 0; i--) {
			this.$methodToggles[i].addEventListener('click', this.methodToggleClick.bind(this));
		}

		for (var i = this.$legendComponents.length - 1; i >= 0; i--) {
			this.$rotatorComponents[i].addEventListener('click', this.componentClick.bind(this));
			this.$legendComponents[i].addEventListener('click', this.componentClick.bind(this));
			this.$legendComponents[i].addEventListener('mousemove', this.componentMousemove.bind(this));
			this.$rotatorBullets[i].addEventListener('mousemove', this.bulletMousemove.bind(this));
			this.$rotatorComponents[i].addEventListener(
				'mouseleave',
				this.componentMouseleave.bind(this)
			);
			this.$legendComponents[i].addEventListener('mouseleave', this.componentMouseleave.bind(this));
		}
		window.addEventListener('optimizedResize', this.resizeLegend.bind(this));
	},

	methodToggleClick: function (e) {
		var $target = e.currentTarget;
		var i = $target.getAttribute('data-index');
		this.flkty.select(i);
	},

	initRotator: function () {
		this.flkty = new Flickity(this.$rotator, {
			pageDots: false,
		});

		this.flkty.on('change', this.flickityChange.bind(this));
	},

	flickityChange: function (i) {
		this.changeMethod(i);
		this.deactivateAllComponents(i);
	},

	changeMethod: function (i) {
		var self = this;
		this.$methodToggles[this.currentMethodIndex].classList.remove('active');
		self.$methodToggles[i].classList.add('active');
		this.$legendCells[this.currentMethodIndex].classList.remove('active');
		this.$legendCells[i].style.display = 'block';
		setTimeout(function () {
			self.$legendCells[self.currentMethodIndex].removeAttribute('style');
			self.$legendCells[i].classList.add('active');
			self.currentMethodIndex = i;
			self.resizeLegend();
		}, 500);
	},

	initLegend: function () {
		this.$legendCells[0].style.display = 'block';
		this.$legendCells[0].classList.add('active');
		this.resizeLegend();
	},

	componentClick: function (e) {
		var $target = e.currentTarget;
		this.changeComponent($target, true, false);
	},

	changeComponent: function ($target, shouldToggle, viaHover) {
		var slug = $target.getAttribute('data-slug');
		var $rotatorComponent = document.querySelector(
			'#moviXLMethods .methodRotator .component[data-slug="' + slug + '"]'
		);
		var $legendComponent = document.querySelector(
			'#moviXLMethods .methodLegend .component[data-slug="' + slug + '"]'
		);
		var alreadyActive = $target.classList.contains('active');

		//avoid animation delays after interaction
		$rotatorComponent.classList.add('interacted');

		if (!alreadyActive || (!viaHover && this.hoverBasedActiveState)) {
			this.deactivateAllComponents();
			$legendComponent.classList.add('active');
			$rotatorComponent.classList.add('active');
			this.hoverBasedActiveState = viaHover;
			if (!viaHover) this.hoverEnabled = false;
		} else if (alreadyActive && shouldToggle) {
			this.deactivateAllComponents();
		}
	},

	deactivateAllComponents: function () {
		this.hoverEnabled = true;
		this.hoverBasedActiveState = false;
		for (var i = this.$legendComponents.length - 1; i >= 0; i--) {
			this.$legendComponents[i].classList.remove('active');
			this.$rotatorComponents[i].classList.remove('active');
		}
	},

	bulletMousemove: function (e) {
		if (!this.hoverEnabled) return;
		var $target = e.currentTarget.parentNode;
		this.changeComponent($target, false, true);
	},

	componentMouseleave: function (_e) {
		if (!this.hoverEnabled) return;
		this.deactivateAllComponents();
	},

	componentMousemove: function (e) {
		if (!this.hoverEnabled) return;
		var $target = e.currentTarget;
		this.changeComponent($target, false, true);
	},

	resizeLegend: function () {
		var height = this.$legendCells[this.currentMethodIndex].clientHeight;
		this.$legend.style.height = height + 'px';
	},
};
mxlMethods.init();
